<template>
  <div class="main-wrapper" v-if="tags">
    <el-tabs v-model="resourceType" v-on:tab-click="btnNavClick">
      <el-tab-pane label="模板标签" name="Theme"></el-tab-pane>
      <el-tab-pane label="插件标签" name="Extension"></el-tab-pane>
    </el-tabs>

    <el-table :data="tags" style="width: 100%">
      <el-table-column label="标签">
        <template #default="scope">
          {{ scope.row }}
        </template>
      </el-table-column>
      <el-table-column width="180" label="操作">
        <template #default="scope">
          <el-link type="danger" @click.prevent="btnDeleteClick(scope.row)">删 除</el-link>
        </template>
      </el-table-column>
    </el-table>

    <div style="height: 10px"></div>

    <el-row>
      <el-button type="primary" plain style="margin-left: 0px" @click="btnAddClick">新 增</el-button>
    </el-row>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import utils from '@/utils';
import api from '@/api/admin/tags';

interface IState {
  resourceType: string;
  tags: string[];
}

export default defineComponent({
  data() {
    return {
      resourceType: 'Theme',
      tags: [],
    } as IState;
  },
  methods: {
    apiGet() {
      api.get(
        {
          resourceType: this.resourceType,
        },
        (res) => {
          this.tags = res.tags;
        },
      );
    },

    apiAdd(tag: string) {
      api.add(
        {
          resourceType: this.resourceType,
          tag,
        },
        (res) => {
          if (!res) return;
          utils.success('标签添加成功！');
          this.apiGet();
        },
      );
    },

    apiDelete(tag: string) {
      api.delete(
        {
          resourceType: this.resourceType,
          tag,
        },
        (res) => {
          if (!res) return;
          this.apiGet();
        },
      );
    },

    btnNavClick() {
      this.apiGet();
    },

    btnAddClick() {
      utils.prompt(
        {
          title: '提示',
          message: '请输入标签',
          confirmButtonText: '确定',
          cancelButtonText: '取消',
        },
        (value) => {
          this.apiAdd(value);
        },
      );
    },

    btnDeleteClick(tag: string) {
      utils.alertDelete(
        {
          title: '删除标签',
        },
        () => {
          this.apiDelete(tag);
        },
      );
    },
  },
  mounted() {
    this.apiGet();
  },
});
</script>
